import { useEffect } from 'react'

import { useManagementSearchUnitTaskQueue, useManagementSearchUnitTaskQueueCount } from '@apps-common/apis/management/unit-task/task-queue'
import { useTaskQueueUpdates } from '@apps-common/apps/portal/pages/units/pages/program-tasks/hooks'
import { TaskQueueHeader } from '@apps-common/apps/portal/pages/units/pages/program-tasks/pages/task-queue/components'
import { buildTableKeys } from '@apps-common/apps/portal/pages/units/pages/program-tasks/pages/task-queue/components/tasks-queue-table/table-keys'
import { Table } from '@apps-common/components/elements/table'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { PageClearFilterButton, PageResultsCount } from '@apps-common/components/page'
import { usePortalFirebaseUser } from '@apps-common/hooks/usePortalFirebaseUser'
import { useUnitTaskQueueFilterStore } from '@apps-common/stores/useUnitTaskQueueFilterStore'

const containerId = 'tasks-queue-table-container'

interface IProps {
  taskGroupId?: number
}

export const TasksQueueTableView: React.FC<IProps> = ({ taskGroupId }) => {
  const user = usePortalFirebaseUser()
  const filter = useUnitTaskQueueFilterStore()

  useEffect(() => {
    filter.setSkip(0)
  }, [])

  const {
    isLoading: countIsLoading,
    isError: countIsError,
    data: countData,
    refetch: countRefetch
  } = useManagementSearchUnitTaskQueueCount({
    taskGroupId: taskGroupId || 0,
    model: filter
  })

  const {
    isLoading: queueLoading,
    isFetching: queueFetching,
    isRefetching: queueRefetching,
    isError: queueError,
    data: queue,
    refetch: queueRefetch
  } = useManagementSearchUnitTaskQueue({
    taskGroupId: taskGroupId || 0,
    model: filter
  })

  console.log(queue)

  const allLoading = queueLoading || queueFetching || queueError || countIsLoading || countIsError

  useTaskQueueUpdates(containerId, queueLoading, allLoading, queue || [])

  const countLoading = countIsLoading || countIsError
  const loading = (queueLoading || queueFetching || queueError || countLoading) && !queueRefetching

  return (
    <>
      <TaskQueueHeader>
        <div className='flex items-center justify-between'>
          <PageResultsCount loading={countLoading} count={countData} extraText={filter.status?.replaceAll('_', ' ')} />
          <PageClearFilterButton filter={filter} filterKeyWordsFunc={filter.getFilteredByKeywords} callback={filter.clear} />
        </div>
      </TaskQueueHeader>
      <LayoutContainer id={containerId}>
        <LayoutPadding topPadding='pt-[20px]'>
          <div className='w-full'>
            <Table
              loading={loading}
              loadingSkeletonHeight='!leading-[36px]'
              placeholderSkeletonHeight='!leading-[36px]'
              pagination={{
                loading: countLoading,
                count: countData?.resultCount,
                skip: filter.skip,
                take: filter.take,
                onSkipChanged: (value) => filter.setSkip(value),
                onTakeChanged: (value) => filter.setTake(value)
              }}
              keysId={`${filter.status}-${user?.isMonitoringCentre}`}
              keys={buildTableKeys()}
              data={queue}
              onSkipChanged={(value) => filter.setSkip(value)}
              onTakeChanged={(value) => filter.setTake(value)}
            />
          </div>
        </LayoutPadding>
      </LayoutContainer>
    </>
  )
}
